module.exports = __webpack_public_path__ + "static/media/CIPLA.e428d4a1.txt";